module.exports = __webpack_public_path__ + "static/media/explore-3.98e61038.jpg";